<script>
import {Message} from "element-ui";
import {deleteResource, pageResource, saveOrUpdateResource} from "@/api/user";

export default {
  name: 'Resource',
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      resourceList: [],
      visible: false,
      resource: {},
      submitLoading: false,
      searchKeyword: '',
      parent : null,
      clientType : 'PLATFORM',
      bizLine : 'WASTE',
    }
  },
  mounted() {
    this.fetchResourceList();
  },
  methods: {
    // 为表格行添加交替样式
    tableRowClassName({row, rowIndex}) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    openEditDrawer(item) {
      if (this.resource.id) {
        this.resource = {}
      }
      if (item){
        // 设置层级
        this.parent = item ;
      }
      this.visible = !this.visible;
    },

    async onChangeClientType(){
      await this.fetchResourceList();
    },

    async fetchResourceList() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
          filter: [
            {
              name: 'parentId',
              type: 'EQ',
              value: 0
            },
            {
              name: 'clientType',
              type: 'EQ',
              value: this.clientType
            }
          ],
          sorted: [{
            name: 'seq',
            type: 'ASC'
          }]
        }
        if (this.searchKeyword) {
          params.filter.push({
            name: 'name',
            type: 'LIKE',
            value: this.searchKeyword
          })
        }

        if (this.clientType === 'SEM'){
          params.filter.push({
            name: 'bizLine',
            type: 'EQ',
            value: this.bizLine
          })
        }

        // 这里应该调用实际的 API
        const resp = await pageResource(params);
        this.resourceList = (resp.result.records || []).map(item => ({
          ...item,
          hasChildren: true // 假设所有资源都有子资源，实际情况可能需要根据 API 返回判断
        }));
        this.total = resp.result.total;
      } catch (e) {
        console.log(e)
        this.resourceList = []; // 确保有默认空数组
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchResourceList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchResourceList()
    },

    async submitResource() {
      console.log('保存资源:', this.resource)
      if (this.submitLoading) return
      if (!this.resource.name) {
        Message.error('请输入名称');
        return;
      }
      if (!this.resource.code) {
        Message.error('请输入编码');
        return;
      }

      this.submitLoading = true;

      const param = {
        ...this.resource
      }
      try {
        if (!param.id) {
          // 新增
          param.parentId =  this.parent ? this.parent.id : 0;

        }
        console.log('保存资源:', param)
        const res = await saveOrUpdateResource(param);
        if (res && res.code === "0000") {
          Message.success('新增资源成功');
        }
      } catch (e) {
        console.log('操作失败',e)
        Message.error('操作失败');
      } finally {
        this.submitLoading = false;
      }

      this.cleanResource();
      this.fetchResourceList();
      this.$refs.editDrawer.closeDrawer()
    },

    async deleteResource(id) {
      this.$confirm('此操作将永久删除该资源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          deleteResource(id).then( res => {
            if (res && res.code === "0000") {
              Message.success(`删除成功`);
              this.cleanResource();
              this.fetchResourceList();
            }else {
              Message.error(res.message)
            }
          })

        } catch (e) {
          Message.error('删除失败');
        }
      }).catch(() => {

      });

    },

    // 加载子资源
    async loadChildResources(tree, treeNode, resolve) {
      try {
        // 调用实际的 API，传入 parentId
        const params = {
          current: 1,
          size: 100, // 加载所有子资源
          filter: [
            {
              name: 'parentId',
              type: 'EQ',
              value: tree.id
            }
          ],
          sorted: [{
            name: 'seq',
            type: 'ASC'
          }]
        };
        const resp = await pageResource(params);
        resolve(resp.result.records || []);
      } catch (e) {
        console.error('加载子资源失败:', e);
        resolve([]);
      }
    },

    handleEdit(item) {
      this.resource = {
        ...item
      }
      this.visible = true

    },

    cleanResource() {
      this.resource = {}
      this.currentPage = 1
      this.resourceList = []
    },

    handleSearch() {
      this.cleanResource();
      this.fetchResourceList()
    },

    handleClose(done) {
      this.parent = null;
      this.resource = {} ;
      done();
    }

  },
}
</script>

<template>
  <div>
    <el-card class="main-card">
      <div class="card-header">
        <div style="display: flex; align-items: center; gap: 16px;">
          <!-- 搜索区域 -->
          <div class="filter-bar">
            <el-input v-model="searchKeyword" placeholder="搜索名称或编码" clearable class="search-input" @keyup.enter="handleSearch"  style="width: 280px">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch" />
            </el-input>
            <el-radio-group v-model="clientType" @change="onChangeClientType">
              <el-radio label="PLATFORM" border>平台</el-radio>
              <el-radio label="SEM" border>安全环境管理平台</el-radio>
            </el-radio-group>

            <el-radio-group v-if="clientType === 'SEM'" v-model="bizLine" @change="onChangeClientType">
              <el-radio label="WASTE">危废品</el-radio>
              <el-radio label="CHEMICAL">危化品</el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-button type="primary" @click="openEditDrawer()" size="small">新增菜单组</el-button>
      </div>

      <el-table
          :data="resourceList"
          border stripe highlight-current-row
          class="device-table"
          :row-class-name="tableRowClassName"
          row-key="id"
          lazy
          :load="loadChildResources"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >

        <el-table-column prop="name" label="名称" min-width="160" show-overflow-tooltip/>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === '1'">菜单</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编码" show-overflow-tooltip/>
        <el-table-column prop="path" label="菜单路径" show-overflow-tooltip/>
        <el-table-column prop="apiUrl" label="菜单URL" show-overflow-tooltip/>
        <el-table-column prop="seq" label="排序"/>
        <el-table-column prop="icon" label="图标">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
<!--        <el-table-column prop="parentId" label="上级ID"/>-->
        <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
        <el-table-column prop="createdTime" label="创建时间" min-width="120" show-overflow-tooltip/>
        <el-table-column prop="updatedTime" label="更新时间" min-width="120" show-overflow-tooltip/>

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.parentId === 0" size="mini" type="text" @click="openEditDrawer(scope.row)">
              新增子菜单
            </el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="text" @click="deleteResource(scope.row.id)" style="color: red">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"
                       class="pagination"></el-pagination>
      </div>
    </el-card>

    <el-drawer
        :title="resource.id ? '编辑资源': '新增资源'"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
        :before-close="handleClose"
    >
      <div class="edit-container">

        <el-form ref="resourceForm" :model="resource" label-width="120px">
          <el-form-item v-if="parent" label="上级资源">
            <span>{{parent.name}}</span>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="resource.name" clearable/>
          </el-form-item>
          <el-form-item label="编码">
            <el-input v-model="resource.code" clearable/>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="resource.type" placeholder="请选择类型" clearable class="form-select">
              <el-option label="菜单" value="1"/>
              <el-option label="按钮" value="2"/>
              <el-option label="API" value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="客户端类型">
            <el-select v-model="resource.clientType" placeholder="请选择客户端类型" clearable class="form-select">
              <el-option label="平台后台" value="PLATFORM"/>
              <el-option label="安全环境管理后台" value="SEM"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="resource.clientType === 'SEM'" label="客户端类型">
            <el-select v-model="resource.bizLine" placeholder="请选择业务线" class="form-select">
              <el-option label="危废" value="WASTE"/>
              <el-option label="危化品" value="CHEMICAL"/>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单路径">
            <el-input v-model="resource.path" clearable/>
          </el-form-item>
          <el-form-item label="菜单URL">
            <el-input v-model="resource.apiUrl" clearable/>
          </el-form-item>
          <el-form-item label="请求方法">
            <el-select v-model="resource.apiMethod" placeholder="请选择请求方法" clearable class="form-select">
              <el-option label="GET" value="GET"/>
              <el-option label="POST" value="POST"/>
              <el-option label="PUT" value="PUT"/>
              <el-option label="DELETE" value="DELETE"/>
            </el-select>
          </el-form-item>
          <el-form-item label="图标">
            <el-input v-model="resource.icon" clearable placeholder="例如: el-icon-s-home"/>
          </el-form-item>
          <el-form-item label="序号">
            <el-input v-model.number="resource.seq" type="number" clearable/>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="resource.remark" type="textarea" clearable/>
          </el-form-item>
        </el-form>
        <div class="edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitResource" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>

</template>

<style scoped>

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.edit-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .edit-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 1;
    padding: 12px;
    position: fixed;
    bottom: 0;
    right: 0;
  }
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 200px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}


</style>
